module.exports = __webpack_public_path__ + "img/d8c30f6.svg";